<!-- eslint-disable vue/no-v-html -->
<template>
	<span
		:class="[$style.icon, !filled && $style.fill, hasStroke && !filled && $style.stroke, $style[name], $style[size]]"
		:data-test="`common-icon-${name}`"
		:aria-hidden="ariaHidden"
		v-html="icon"
	/>
</template>

<script setup lang="ts">
import { type icons, iconAriaLabels } from './icons';
import type { IconSize } from './common-icon';

import acceptIcon from '@nlo-assets/icons/accept.svg?raw';
import accountBgIcon from '@nlo-assets/icons/account-bg.svg?raw';
import accountIcon from '@nlo-assets/icons/account.svg?raw';
import addBgIcon from '@nlo-assets/icons/add-bg.svg?raw';
import addIcon from '@nlo-assets/icons/add.svg?raw';
import ageRestrictionIcon from '@nlo-assets/icons/age-restriction.svg?raw';
import ArrowRightShortIcon from '@nlo-assets/icons/arrow-right-short.svg?raw';
import ArrowRightIcon from '@nlo-assets/icons/arrow-right.svg?raw';
import BagIcon from '@nlo-assets/icons/bag.svg?raw';
import BlockIcon from '@nlo-assets/icons/block.svg?raw';
import calendarIcon from '@nlo-assets/icons/calendar.svg?raw';
import CallIcon from '@nlo-assets/icons/call.svg?raw';
import CameraIcon from '@nlo-assets/icons/camera.svg?raw';
import CartIcon from '@nlo-assets/icons/cart.svg?raw';
import chanceIcon from '@nlo-assets/icons/chance.svg?raw';
import chatIcon from '@nlo-assets/icons/chat.svg?raw';
import CheckBgIcon from '@nlo-assets/icons/check-bg.svg?raw';
import CheckmarkIcon from '@nlo-assets/icons/checkmark.svg?raw';
import ChevronDownIcon from '@nlo-assets/icons/chevron-down.svg?raw';
import ChevronLeftIcon from '@nlo-assets/icons/chevron-left.svg?raw';
import ChevronRightIcon from '@nlo-assets/icons/chevron-right.svg?raw';
import ChevronUpIcon from '@nlo-assets/icons/chevron-up.svg?raw';
import ClearIcon from '@nlo-assets/icons/clear.svg?raw';
import CloseBgIcon from '@nlo-assets/icons/close-bg.svg?raw';
import CloseIcon from '@nlo-assets/icons/close.svg?raw';
import CouponIcon from '@nlo-assets/icons/coupon.svg?raw';
import CreditcardIcon from '@nlo-assets/icons/creditcard.svg?raw';
import CustomerSupportIcon from '@nlo-assets/icons/customer-support.svg?raw';
import DeleteIcon from '@nlo-assets/icons/delete.svg?raw';
import DownvoteIcon from '@nlo-assets/icons/downvote.svg?raw';
import DrawDateIcon from '@nlo-assets/icons/draw-date.svg?raw';
import EditIcon from '@nlo-assets/icons/edit.svg?raw';
import EraseIcon from '@nlo-assets/icons/erase.svg?raw';
import ErrorIcon from '@nlo-assets/icons/error.svg?raw';
import FacebookLogoIcon from '@nlo-assets/icons/facebook-logo.svg?raw';
import GiftIcon from '@nlo-assets/icons/gift.svg?raw';
import HintIcon from '@nlo-assets/icons/hint.svg?raw';
import StrokeIcon from '@nlo-assets/icons/home-stroke.svg?raw';
import HomeIcon from '@nlo-assets/icons/home.svg?raw';
import IdealIcon from '@nlo-assets/icons/ideal.svg?raw';
import IdinIcon from '@nlo-assets/icons/idin.svg?raw';
import InboxIcon from '@nlo-assets/icons/inbox.svg?raw';
import InfoIcon from '@nlo-assets/icons/info.svg?raw';
import LogoIcon from '@nlo-assets/icons/instagram-logo.svg?raw';
import AddIcon from '@nlo-assets/icons/kl-shopping-cart-add.svg?raw';
import KlShoppingCartIcon from '@nlo-assets/icons/kl-shopping-cart.svg?raw';
import LinkedinLogoIcon from '@nlo-assets/icons/linkedin-logo.svg?raw';
import LocationIcon from '@nlo-assets/icons/location.svg?raw';
import LockIcon from '@nlo-assets/icons/lock.svg?raw';
import LogoutIcon from '@nlo-assets/icons/logout.svg?raw';
import LottoXlIcon from '@nlo-assets/icons/lotto-xl.svg?raw';
import InputIcon from '@nlo-assets/icons/manual-input.svg?raw';
import MenuIcon from '@nlo-assets/icons/menu.svg?raw';
import MessengerLogoIcon from '@nlo-assets/icons/messenger-logo.svg?raw';
import MoreInfoQuestionMarkIcon from '@nlo-assets/icons/more-info-question-mark.svg?raw';
import NoTicketIcon from '@nlo-assets/icons/no-ticket.svg?raw';
import NotificationIcon from '@nlo-assets/icons/notification.svg?raw';
import PayIcon from '@nlo-assets/icons/pay.svg?raw';
import PayoutIcon from '@nlo-assets/icons/payout.svg?raw';
import PinIcon from '@nlo-assets/icons/pin.svg?raw';
import PlayIcon from '@nlo-assets/icons/play.svg?raw';
import PointsIcon from '@nlo-assets/icons/points.svg?raw';
import PrizeIcon from '@nlo-assets/icons/prize.svg?raw';
import ProgressActivityIcon from '@nlo-assets/icons/progress-activity.svg?raw';
import QrCodeIcon from '@nlo-assets/icons/qr-code.svg?raw';
import RejectIcon from '@nlo-assets/icons/reject.svg?raw';
import ReloadIcon from '@nlo-assets/icons/reload.svg?raw';
import RewardIcon from '@nlo-assets/icons/reward.svg?raw';
import ScanIcon from '@nlo-assets/icons/scan.svg?raw';
import ScratchExplainerIcon from '@nlo-assets/icons/scratch-explainer.svg?raw';
import SearchIcon from '@nlo-assets/icons/search.svg?raw';
import SettingsIcon from '@nlo-assets/icons/settings.svg?raw';
import ShakeIcon from '@nlo-assets/icons/shake.svg?raw';
import ShuffleIcon from '@nlo-assets/icons/shuffle.svg?raw';
import StakeIcon from '@nlo-assets/icons/stake.svg?raw';
import ClubIcon from '@nlo-assets/icons/stl-club.svg?raw';
import GroupplayIcon from '@nlo-assets/icons/stl-groupplay.svg?raw';
import StlXlIcon from '@nlo-assets/icons/stl-xl.svg?raw';
import StoreIcon from '@nlo-assets/icons/store.svg?raw';
import SubscriptionTicketsIcon from '@nlo-assets/icons/subscription-tickets.svg?raw';
import SwapIcon from '@nlo-assets/icons/swap.svg?raw';
import TicketCheckedIcon from '@nlo-assets/icons/ticket-checked.svg?raw';
import TicketIcon from '@nlo-assets/icons/ticket.svg?raw';
import TicketsIcon from '@nlo-assets/icons/tickets.svg?raw';
import TiktokLogoIcon from '@nlo-assets/icons/tiktok-logo.svg?raw';
import TooltipIcon from '@nlo-assets/icons/tooltip.svg?raw';
import TooltipIIcon from '@nlo-assets/icons/tooltip-i.svg?raw';
import TouchIdIcon from '@nlo-assets/icons/touch-id.svg?raw';
import UpvoteIcon from '@nlo-assets/icons/upvote.svg?raw';
import VerifiedIcon from '@nlo-assets/icons/verified.svg?raw';
import VisibilityOffIcon from '@nlo-assets/icons/visibility-off.svg?raw';
import VisibilityOnIcon from '@nlo-assets/icons/visibility-on.svg?raw';
import WalletIcon from '@nlo-assets/icons/wallet.svg?raw';
import WarningIcon from '@nlo-assets/icons/warning.svg?raw';
import XLogoIcon from '@nlo-assets/icons/x-logo.svg?raw';
import YoutubeLogoIcon from '@nlo-assets/icons/youtube-logo.svg?raw';

const props = withDefaults(
	defineProps<{
		name: (typeof icons)[number];
		filled?: boolean;
		ariaLabel?: string;
		ariaHidden?: boolean;
		size?: IconSize;
	}>(),
	{ filled: false, ariaLabel: undefined, ariaHidden: false, size: 'font-size' },
);

const hasStroke = computed(() => icon.value.includes('stroke'));

const icon = computed(() => {
	let rawIcon = '';

	switch (props.name) {
		case 'accept':
			rawIcon = acceptIcon;
			break;
		case 'account-bg':
			rawIcon = accountBgIcon;
			break;
		case 'account':
			rawIcon = accountIcon;
			break;
		case 'add-bg':
			rawIcon = addBgIcon;
			break;
		case 'add':
			rawIcon = addIcon;
			break;
		case 'age-restriction':
			rawIcon = ageRestrictionIcon;
			break;
		case 'arrow-right-short':
			rawIcon = ArrowRightShortIcon;
			break;
		case 'arrow-right':
			rawIcon = ArrowRightIcon;
			break;
		case 'bag':
			rawIcon = BagIcon;
			break;
		case 'block':
			rawIcon = BlockIcon;
			break;
		case 'calendar':
			rawIcon = calendarIcon;
			break;
		case 'call':
			rawIcon = CallIcon;
			break;
		case 'camera':
			rawIcon = CameraIcon;
			break;
		case 'cart':
			rawIcon = CartIcon;
			break;
		case 'chance':
			rawIcon = chanceIcon;
			break;
		case 'chat':
			rawIcon = chatIcon;
			break;
		case 'check-bg':
			rawIcon = CheckBgIcon;
			break;
		case 'checkmark':
			rawIcon = CheckmarkIcon;
			break;
		case 'chevron-down':
			rawIcon = ChevronDownIcon;
			break;
		case 'chevron-left':
			rawIcon = ChevronLeftIcon;
			break;
		case 'chevron-right':
			rawIcon = ChevronRightIcon;
			break;
		case 'chevron-up':
			rawIcon = ChevronUpIcon;
			break;
		case 'clear':
			rawIcon = ClearIcon;
			break;
		case 'close-bg':
			rawIcon = CloseBgIcon;
			break;
		case 'close':
			rawIcon = CloseIcon;
			break;
		case 'coupon':
			rawIcon = CouponIcon;
			break;
		case 'creditcard':
			rawIcon = CreditcardIcon;
			break;
		case 'customer-support':
			rawIcon = CustomerSupportIcon;
			break;
		case 'delete':
			rawIcon = DeleteIcon;
			break;
		case 'downvote':
			rawIcon = DownvoteIcon;
			break;
		case 'draw-date':
			rawIcon = DrawDateIcon;
			break;
		case 'edit':
			rawIcon = EditIcon;
			break;
		case 'erase':
			rawIcon = EraseIcon;
			break;
		case 'error':
			rawIcon = ErrorIcon;
			break;
		case 'facebook-logo':
			rawIcon = FacebookLogoIcon;
			break;
		case 'gift':
			rawIcon = GiftIcon;
			break;
		case 'hint':
			rawIcon = HintIcon;
			break;
		case 'home-stroke':
			rawIcon = StrokeIcon;
			break;
		case 'home':
			rawIcon = HomeIcon;
			break;
		case 'ideal':
			rawIcon = IdealIcon;
			break;
		case 'idin':
			rawIcon = IdinIcon;
			break;
		case 'inbox':
			rawIcon = InboxIcon;
			break;
		case 'info':
			rawIcon = InfoIcon;
			break;
		case 'instagram-logo':
			rawIcon = LogoIcon;
			break;
		case 'kl-shopping-cart-add':
			rawIcon = AddIcon;
			break;
		case 'kl-shopping-cart':
			rawIcon = KlShoppingCartIcon;
			break;
		case 'linkedin-logo':
			rawIcon = LinkedinLogoIcon;
			break;
		case 'location':
			rawIcon = LocationIcon;
			break;
		case 'lock':
			rawIcon = LockIcon;
			break;
		case 'logout':
			rawIcon = LogoutIcon;
			break;
		case 'lotto-xl':
			rawIcon = LottoXlIcon;
			break;
		case 'manual-input':
			rawIcon = InputIcon;
			break;
		case 'menu':
			rawIcon = MenuIcon;
			break;
		case 'messenger-logo':
			rawIcon = MessengerLogoIcon;
			break;
		case 'more-info-question-mark':
			rawIcon = MoreInfoQuestionMarkIcon;
			break;
		case 'no-ticket':
			rawIcon = NoTicketIcon;
			break;
		case 'notification':
			rawIcon = NotificationIcon;
			break;
		case 'pay':
			rawIcon = PayIcon;
			break;
		case 'payout':
			rawIcon = PayoutIcon;
			break;
		case 'pin':
			rawIcon = PinIcon;
			break;
		case 'play':
			rawIcon = PlayIcon;
			break;
		case 'points':
			rawIcon = PointsIcon;
			break;
		case 'prize':
			rawIcon = PrizeIcon;
			break;
		case 'progress-activity':
			rawIcon = ProgressActivityIcon;
			break;
		case 'qr-code':
			rawIcon = QrCodeIcon;
			break;
		case 'reject':
			rawIcon = RejectIcon;
			break;
		case 'reload':
			rawIcon = ReloadIcon;
			break;
		case 'reward':
			rawIcon = RewardIcon;
			break;
		case 'scan':
			rawIcon = ScanIcon;
			break;
		case 'scratch-explainer':
			rawIcon = ScratchExplainerIcon;
			break;
		case 'search':
			rawIcon = SearchIcon;
			break;
		case 'settings':
			rawIcon = SettingsIcon;
			break;
		case 'shake':
			rawIcon = ShakeIcon;
			break;
		case 'shuffle':
			rawIcon = ShuffleIcon;
			break;
		case 'stake':
			rawIcon = StakeIcon;
			break;
		case 'stl-club':
			rawIcon = ClubIcon;
			break;
		case 'stl-groupplay':
			rawIcon = GroupplayIcon;
			break;
		case 'stl-xl':
			rawIcon = StlXlIcon;
			break;
		case 'store':
			rawIcon = StoreIcon;
			break;
		case 'subscription-tickets':
			rawIcon = SubscriptionTicketsIcon;
			break;
		case 'swap':
			rawIcon = SwapIcon;
			break;
		case 'ticket-checked':
			rawIcon = TicketCheckedIcon;
			break;
		case 'ticket':
			rawIcon = TicketIcon;
			break;
		case 'tickets':
			rawIcon = TicketsIcon;
			break;
		case 'tiktok-logo':
			rawIcon = TiktokLogoIcon;
			break;
		case 'tooltip':
			rawIcon = TooltipIcon;
			break;
		case 'tooltip-i':
			rawIcon = TooltipIIcon;
			break;
		case 'touch-id':
			rawIcon = TouchIdIcon;
			break;
		case 'upvote':
			rawIcon = UpvoteIcon;
			break;
		case 'verified':
			rawIcon = VerifiedIcon;
			break;
		case 'visibility-off':
			rawIcon = VisibilityOffIcon;
			break;
		case 'visibility-on':
			rawIcon = VisibilityOnIcon;
			break;
		case 'wallet':
			rawIcon = WalletIcon;
			break;
		case 'warning':
			rawIcon = WarningIcon;
			break;
		case 'x-logo':
			rawIcon = XLogoIcon;
			break;
		case 'youtube-logo':
			rawIcon = YoutubeLogoIcon;
			break;
	}

	// Inject aria-label as it's not valid on span elements.
	return rawIcon.replace('<svg', `<svg aria-label="${ariaLabelWithDefault.value}"`);
});

const ariaLabelWithDefault = computed(() => props.ariaLabel || iconAriaLabels[props.name]);
</script>

<style lang="scss" module>
.icon {
	line-height: 0; // Fix to make icons appear in a box as high as the font size.

	&.font-size {
		svg {
			width: 1em;
			height: 1em;
		}
	}

	&.m {
		svg {
			width: var(--icons--icon-size-m);
			height: var(--icons--icon-size-m);
		}
	}

	&.s {
		svg {
			width: var(--icons--icon-size-s);
			height: var(--icons--icon-size-s);
		}
	}
}

.fill,
.fill > * {
	fill: currentColor !important;
}
.stroke,
.stroke * {
	stroke: currentColor !important;
}

/* Animations per icon */

.delete {
	svg {
		overflow: visible;
	}

	&:hover {
		:global(#lid) {
			animation: lift-lid 300ms ease;
		}
	}

	@keyframes lift-lid {
		0%,
		100% {
			transform: translateY(0);
		}
		50% {
			transform: rotate(-10deg) translateY(-2px);
		}
	}
}

.progress-activity svg {
	animation: rotate 1s linear infinite;
	transform-origin: center center;

	@keyframes rotate {
		to {
			transform: rotate(1turn);
		}
	}
}
</style>
